const duration = 400;

const overlay = document.getElementById("overlay") as HTMLImageElement;

function animate(duration, callbacks) {
  callbacks.before();

  let startTime = null;

  const tick = (t) => {
    if (startTime === null) {
      startTime = t;
    }

    const progress = Math.min(1, Math.max(0, (t - startTime) / duration));

    if (progress >= 1) {
      callbacks.after();
      return;
    }

    requestAnimationFrame(tick);

    const frame = Math.floor(progress * 100)
      .toString()
      .padStart(4, "0");

    overlay.src = `/assets/${frame}.webp`;
  };

  tick(performance.now());
}

export default {
  async leave({ current }) {
    return new Promise((resolve) => {
      current.container.style.transition = `all ${duration}ms`;
      current.container.style.opacity = 0;
      current.container.style.transform = "translateY(-50px)";

      // animate(1200, {
      //   before: () => {
      //     overlay.style.opacity = '0';
      //     setTimeout(() => {
      //       overlay.style.transition = "opacity 0.2s";
      //       overlay.style.opacity = '0.05';
      //     });

      //     setTimeout(() => {
      //       overlay.style.opacity = '0';
      //     }, 800);
      //   },
      //   after: () => {},
      // });

      setTimeout(resolve, duration);
    });
  },

  async enter({ next }) {
    return new Promise((resolve) => {
      next.container.style.opacity = 0;

      setTimeout(() => {
        next.container.style.transition = `all ${duration / 4}ms`;
        next.container.style.opacity = 1;

        setTimeout(resolve, duration);
      }, 50);
    });
  },
};
